
import {
    FormInput,
    FormTextInput,
    FormChipsInput,
    FormDateRangeInput,
    FormDateTimeInput,
    FormDropdownInput,
} from "stentor-models";

export function isFormTextInput(field: FormInput): field is FormTextInput {
    return !!field && field.type === "TEXT";
}

export function isFormChipsInput(field: FormInput): field is FormChipsInput {
    return !!field && field.type === "CHIPS";
}

export function isFormDateInput(field: FormInput): field is FormChipsInput {
    return !!field && field.type === "DATE";
}

export function isFormCheckInput(field: FormInput): field is FormChipsInput {
    return !!field && field.type === "CHECK";
}

export function isFormDateRangeInput(field: FormInput): field is FormDateRangeInput {
    return !!field && field.type === "DATERANGE";
}

export function isFormDateTimeInput(field: FormInput): field is FormDateTimeInput {
    return !!field && field.type === "DATETIME";
}

export function isFormDropdownInput(field: FormInput): field is FormDropdownInput {
    return !!field && field.type === "DROPDOWN";
}